import { Navigate } from "react-router-dom";

const Home = () => {
	return <Navigate to="/logs" />;
};

export default Home;
